import React from "react";
import {BreadCrumbItem} from "../../organisms/HeaderSection";
import Page from "../../organisms/Page";
import FormSection from "./FormSection";

const breadCrumbs: BreadCrumbItem[] = [
    {
        path: "/",
        label: "Inicio"
    },
    {
        path: "/servicios",
        label: "Servicios",
    },
    {
        path: "/servicios/entrenamiento",
        label: "Entrenamiento",
    },
    {
        path: "/crear",
        label: "Crear",
        isActive: true
    }
]

function CrearServicioEntrenamiento(){
    return (
        <Page title="Registro de Servicio" description="Creación de servicio de entrenamiento." breadCrumbs={breadCrumbs}>
            <FormSection />
        </Page>
    );
}

export default CrearServicioEntrenamiento;